import {isViewonly} from "./app.js";

export function $createVariant(variant) {
    let variantCount = variant.type === 'service' ? 'Разовое посещение' : `Пакет на ${variant.services[0].count} посещений`,
        variantText = variant.type === 'service' ? variant.title : variant.services[0].title,
        discountText = '',
        variantCost = variant.cart.total_amount;

    if (variant.cart.promotions.length)
        discountText = variant.cart.promotions[0].title;

    return $(`<div data-service-cost="${variantCost}" data-service-id="${variant.id}" class="variant">
		<div class="variant__header">
			<p class="variant__count">${variantCount}</p>
			<p class="variant__name">${variantText}</p>
		</div>
		<div class="variant__info">
			<div class="variant__discount">${discountText}</div>
			<div class="variant__price">
				<span>Цена</span>
				<span class="variant__cost">${variantCost} р</span>
			</div>
		</div>
	</div>`)
}

export async function avalilableTicketForServiceId(serviceId, employeeId, startDate) {
    let ticket = await api.get('tickets', {
        params: {
            service_id: serviceId,
            employee_id: employeeId,
            start_date: startDate
        }
    })

    if (ticket.result && ticket.data.length > 0)
        return ticket.data;
    return false;
}

window.avalilableTicketForServiceId = avalilableTicketForServiceId

export async function loadDetailedAppointment(appointment_id) {
    let appointmentRes = await api.get('class_descriptions', {
        params: {
            appointment_id: appointment_id
        }
    });
    if (appointmentRes && appointmentRes.result && appointmentRes.data) {
        return appointmentRes.data;
    }
    return false
}

export async function clientToClass(appointmentId) {
    return await api.post('client_to_class', {
        appointment_id: appointmentId,
        ticket_id: null
    });
}

export async function clientToPersonal(serviceId, employeeId, slot) {
    let response = await api.post('appointment', {
        service_id: serviceId,
        employee_id: employeeId,
        date_time: slot,
    });

    console.log('clientToPersonal', response)
    if (response && response.result && response?.data?.appointment_id) {
        api.get(`/backend/cron/cacheAppointmentsExclude?employeeId=${employeeId}`)
        console.log('remove trainer')
    }

    return response;
}

export async function appointmentAddFlag(serviceId, employeeId, slot, appointmentId) {
    return await api.post('appointmentAddFlag', {
        serviceId: serviceId,
        employeeId: employeeId,
        datetime: slot,
        appointmentId: appointmentId,
    })
}

window.appointmentAddFlag = appointmentAddFlag

export async function appointmentRemoveFlag(appointmentId) {
    return await api.post('appointmentRemoveFlag', {
        appointmentId: appointmentId,
    })
}

window.appointmentRemoveFlag = appointmentRemoveFlag

export async function clientToSpa(serviceId, employeeId, slot) {
    const response = await api.post('book_record', {
        record_array: [{staff_id: employeeId, service_id: serviceId, datetime: slot}],
    });

    console.log('clientToSpa', response)
    if (response && response.result && response?.data?.record_id) {
        api.get(`/backend/cron/cacheSpaExcluded?staffId=${employeeId}`)
        console.log('remove spa trainer')
    }
    return response
}

export async function loadContacts() {
    let response = await api.get('getContactsConfigJson');
    if (response && response.result && response.data) {
        return {contacts: response.data}
    }
    return {};
}

export function buildContacts(category = 'Рецепция', onlyPhone = false) {
    console.log('buildContacts', category)
    let contact = person.contacts[category];
    if (contact) {
        if(onlyPhone) {
            return $(`<a class="contact" href="tel:${contact.link}"><i class="fa fa-phone"></i> ${contact.text}</a>`)
        }else{
            return $(`<a class="contact" href="tel:${contact.link}"><i class="fa fa-phone"></i> ${contact.text}</a>
            <a class="contact ${contact.chatLink ?? 'hidden'}" href="${contact.chatLink}" target="_blank"><i class="fa-brands ${contact.iconClass} fa-xl"></i> Написать</a>`)
        }
    }
    return null;
}

export async function handleClassRecord($ui, detail) {
    notify.info('Записываемся на занятие');
    $ui.$modalFooter.addClass('overlay-info-visible');

    let response = await clientToClass(detail.appointment_id);

    if (response && response?.result) {
        if (response?.data?.status === 'temporarily_reserved_need_payment') {
            $ui.$additionalInfoModal.text('Запись находится в броне, через 10 минут оно автоматически отменится.');
            await showPaymentOptions($ui, detail.service.id);
        } else {
            notify.success('Успешно записались на занятие');
            window.location = '/personal/my-schedule.html'
        }
    }
    $ui.$modalFooter.removeClass('overlay-info-visible');
}

export async function handlePersonalRecord($ui, serviceId, employeeId, slot) {
    notify.info('Записываемся на занятие');
    $ui.$modalFooter.addClass('overlay-info-visible');

    let response = await clientToPersonal(serviceId, employeeId, slot);

    if (response && response?.result) {
        if (response?.data?.status === 'temporarily_reserved_need_payment') {
            $ui.$additionalInfoModal.text('Запись находится в броне, через 10 минут оно автоматически отменится.');
            await showPaymentOptions($ui, serviceId);
        } else {
            notify.success('Успешно записались на занятие');
            window.location = '/personal/my-schedule.html'
        }
    }
    $ui.$modalFooter.removeClass('overlay-info-visible');
}

export async function handleSpaRecord($ui, serviceId, employeeId, slot) {
    let baloon = notify.info('Записываемся на занятие');
    $ui.$modalFooter.addClass('overlay-info-visible');

    let response = await clientToSpa(serviceId, employeeId, slot);

    if (response && response?.result) {
        if (response?.data?.status === 'temporarily_reserved_need_payment') {
            $ui.$additionalInfoModal.text('Запись находится в броне, через 10 минут оно автоматически отменится.');
            await showPaymentOptions($ui, serviceId);
        } else {
            notify.success('Успешно записались на занятие');
            window.location = '/personal/my-schedule.html'
        }
    }
    $(baloon).remove()
    $ui.$modalFooter.removeClass('overlay-info-visible');
}

export async function handleBuyByBank($ui, variant) {
    $ui.$modalFooter.addClass('overlay-info-visible');
    let recordResult;

    if ($ui.type === 'class')
        recordResult = await clientToClass($ui.data.classObject.appointment_id)

    if ($ui.type === 'personal')
        recordResult = await clientToPersonal($ui.data.personalObject.service.id, $ui.data.personalObject.employee.id, $ui.data.personalObject.start_date)

    if ($ui.type === 'prePersonal')
        recordResult = await clientToPersonal($ui.data.personalObject.service.id, $ui.data.personalObject.trainer.id, $ui.data.personalObject.full_date)

    if ($ui.type === 'preSpa')
        recordResult = {result: true}
    // recordResult = await clientToSpa($ui.data.spaObject.service.id, $ui.data.spaObject.staff.id, $ui.data.spaObject.custom_slot)

    let cart = []
    if (variant.type === 'service') {
        cart = [
            {
                "count": 1,
                "purchase_id": variant.id,
                "service_id": variant.id,
                // "employee_id": "802a2c42-85b1-11e8-a7f0-0050568bd50c",
                // "start_date": "2025-03-04 17:00 +03:00"
            }
        ]
    }

    if (variant.type === 'package') {
        cart = [
            {
                "count": 1,
                "purchase_id": variant.id,
                "service_id": variant.id,
                // "employee_id": "802a2c42-85b1-11e8-a7f0-0050568bd50c",
                // "start_date": "2025-03-04 17:00 +03:00"
            }
        ]
    }

    if (recordResult && recordResult.result) {
        let response = await api.post('payment_link', {
            "transaction_id": generateRandomId(),
            "cart": cart,
            "payment_list": [
                {
                    "type": "card",
                    "amount": variant.cart.total_amount
                }
            ],
            // "payment_info": null,
            // "create_date": "2025-03-03T16:32:00+03:00",
            // "promocode": null
        })

        if (response && response.result && response.data && response.data.link) {
            window.location = response.data.link;
        }
    }
    $ui.$modalFooter.removeClass('overlay-info-visible');

}

export async function handleBuyByDepositV2($e, $ui, variant, depositId) {
    $ui.$controls.addClass('overlay-info-visible');
    let cart = []
    if (variant.type === 'service') {
        cart = [
            {
                "count": 1,
                "purchase_id": variant.id,
                "service_id": variant.id,

                // "employee_id": "802a2c42-85b1-11e8-a7f0-0050568bd50c",
                // "start_date": "2025-03-04 17:00 +03:00"
            }
        ]
    }

    if (variant.type === 'package') {
        cart = [
            {
                "count": 1,
                "purchase_id": variant.id,
                "service_id": variant.id,
                // "employee_id": "802a2c42-85b1-11e8-a7f0-0050568bd50c",
                // "start_date": "2025-03-04 17:00 +03:00"
            }
        ]
    }

    let response = await api.post('payment', {
        "transaction_id": generateRandomId(),
        "cart": cart,
        "payment_list": [
            {
                "type": "deposit",
                "id": depositId,
                "amount": variant.cart.total_amount
            }
        ],
        // "payment_info": null,
        // "create_date": "2025-03-03T16:32:00+03:00",
        // "promocode": null
    })

    if ($ui.type === 'class')
        await drawClassModal($ui.$row, $ui.data.classObject)

    if ($ui.type === 'personal')
        await drawPersonalModal($ui.$row, $ui.data.personalObject)

    if ($ui.type === 'prePersonal')
        await drawPersonalPreModal($ui.$row, $ui.data.personalObject)


    if (response && response.result) {
        notify.success('Успешная покупка');
    } else {
        console.error('payment_error', response)
    }
    /* ВЫВЕСТИ модалку об успешности client_to_class при депозитной оплате*/
    $ui.$controls.removeClass('overlay-info-visible');
}

export async function handleBuyByDeposit($ui, variant, depositId) {
    $ui.$controls.addClass('overlay-info-visible');
    let cart = []
    if (variant.type === 'service') {
        cart = [
            {
                "count": 1,
                "purchase_id": variant.id,
                "service_id": variant.id,

                // "employee_id": "802a2c42-85b1-11e8-a7f0-0050568bd50c",
                // "start_date": "2025-03-04 17:00 +03:00"
            }
        ]
    }

    if (variant.type === 'package') {
        cart = [
            {
                "count": 1,
                "purchase_id": variant.id,
                "service_id": variant.id,
                // "employee_id": "802a2c42-85b1-11e8-a7f0-0050568bd50c",
                // "start_date": "2025-03-04 17:00 +03:00"
            }
        ]
    }

    let response = await api.post('payment', {
        "transaction_id": generateRandomId(),
        "cart": cart,
        "payment_list": [
            {
                "type": "deposit",
                "id": depositId,
                "amount": variant.cart.total_amount
            }
        ],
        // "payment_info": null,
        // "create_date": "2025-03-03T16:32:00+03:00",
        // "promocode": null
    })

    if ($ui.type === 'class')
        await drawClassModal($ui.$row, $ui.data.classObject)

    if ($ui.type === 'personal')
        await drawPersonalModal($ui.$row, $ui.data.personalObject)

    if ($ui.type === 'prePersonal')
        await drawPersonalPreModal($ui.$row, $ui.data.personalObject)


    if (response && response.result) {
        notify.success('Успешная покупка');
    } else {
        console.error('payment_error', response)
    }
    /* ВЫВЕСТИ модалку об успешности client_to_class при депозитной оплате*/
    $ui.$controls.removeClass('overlay-info-visible');
}

export function selectVariant($ui, $variant) {
    console.log($ui)
    let variant = $variant.data('variant');
    $('.variant').removeClass('active');
    $variant.addClass('active');

    let mainDeposit = person.deposits[0],
        depositBalance = mainDeposit.balance,
        depositId = mainDeposit.id;

    if (depositBalance >= variant.cart.total_amount) {
        $ui.$additionalInfoModal.text(`На вашем основном счете достаточно средств (${depositBalance.toLocaleString()}р.) чтобы оплатить эту услугу. Вы можете оплатить ее с личного счета или банковской картой.`);
        $ui.$buttonBuyByDeposit.removeClass('hidden');
        $ui.$buttonBuyByBank.removeClass('hidden');
    } else {
        $ui.$additionalInfoModal.text(`На вашем основном счете не хватает средств (${(variant.cart.total_amount - depositBalance).toLocaleString()}р.) чтобы оплатить эту услугу. Вы можете оплатить ее банковской картой.`);
        $ui.$buttonBuyByDeposit.addClass('hidden');
        $ui.$buttonBuyByBank.removeClass('hidden');
    }
    $ui.$buttonBuyByDeposit.off().on('click', async function () {
        await handleBuyByDeposit($ui, variant, depositId)
    });

    $ui.$buttonBuyByBank.off().on('click', async function () {
        await handleBuyByBank($ui, variant)
    });
}

export async function loadProductVariants(serviceId) {
    return await api.get('class_descriptions_extended', {
        params: {
            service_id: serviceId
        }
    })
}

export async function showPaymentOptions($ui, serviceId) {
    $ui.$variants
        .empty()
        .removeClass('hidden')
        .addClass('overlay-info-visible');

    let productVariants = await loadProductVariants(serviceId)

    if (productVariants && productVariants.result && productVariants?.services?.length) {
        for (let variant of productVariants.services) {
            let $variant = $createVariant(variant);
            $variant.data('variant', variant);
            $variant.on('click', function () {
                selectVariant($ui, $(this))
            });
            $ui.$variants.append($variant);
        }

        $ui.$variants.removeClass('overlay-info-visible');
    } else {
        $ui.$additionalInfoModal.text('Нет доступных оснований для покупки, обратитесь к администратору');
    }
    $ui.$variants.removeClass('overlay-info-visible');
}

const coachCache = new Map();

export async function loadTrainer(employee_id) {
    if (coachCache.has(employee_id)) {
        return coachCache.get(employee_id);
    }

    try {
        let employeeRes = await api.get('employee', {
            params: {employee_id: employee_id}
        });

        if (employeeRes && employeeRes.data) {
            coachCache.set(employee_id, employeeRes.data);
            return employeeRes.data;
        }
    } catch (error) {
        console.error('Ошибка при получении данных сотрудника:', error);
    }

    return false;
}

window.loadTrainer = loadTrainer;

export function findPersonal(array, serviceId, date, employeeId) {
    return array.find(item =>
        item.service.id === serviceId &&
        item.full_date.startsWith(date) &&
        item.trainer.id === employeeId
    );
}

export function findInMyAppointments(appointmentId) {
    return person.plainAppointments.filter(f => f.appointment_id === appointmentId)[0]
}

export function getServiceIdFromUrl() {
    let search = new URLSearchParams(window.location.search);
    return {
        search: search,
        selectedServiceId: search.get('service-id') || search.get('service_id') || false,
        selectedAppointmentId: search.get('appointment-id') || search.get('appointment_id') || false,
        selectedTrainerId: search.get('trainer-id') || search.get('trainer_id') || false,
        selectedServiceType: search.get('type') || false,
        getPayFormDebts: search.has('getPayFormDebts') ? search.get('id') : false,
        getShopFormAuth: search.has('getShopFormAuth') ? search.get('id') : false
    };
}


export function $createHistoryFilter() {
    return $(`<div class="history-filter">
        <div class="history-filter__dates">
            <input type="text" data-date-target class="history-filter__input">
        </div>
        <div class="history-filter__controls">
            <button class="button" data-history-refresh>Показать</button>
            <a target="_blank" class="button" data-history-save hidden>Сохранить отчёт</a>
        </div>
    </div>`);
}

window.$createHistoryFilter = $createHistoryFilter

export async function drawClassModal($row, classObject = false) {
    if (!classObject)
        classObject = $row.data('classObject');

    if (classObject.canceled) {
        return notify.error(`Занятие отменено: ${classObject.reason_for_cancellation}`);
    }

    let $ui = initPaymentModalUi($row, 'class', 'classObject', classObject)
    MicroModal.show('payment-form');
    resetModal($ui)

    let $contacts = buildContacts('ОП');
    $ui.$contacts.empty().append($contacts)

    let trainer = classObject.employee_replacement ? classObject.employee_replacement : classObject.employee;

    if (classObject.commercial) {
        $ui.$payRequirement.removeClass('hidden');
    } else {
        $ui.$payRequirement.addClass('hidden');
    }

    $('.payment-form .appointment-name').text(classObject.service.title);
    $('.payment-form .appointment-room').text(classObject.room.title);
    $('.payment-form .appointment-time').text(moment(classObject.start_date).format('DD.MM.YYYY HH:mm'));
    $('.payment-form .appointment-duration').text(classObject.duration);
    if (classObject?.available_slots === 'unlimited') {
        $('.buy__info--col:nth-child(4)').addClass('hidden')
        $('.buy__info--col:nth-child(5)').addClass('hidden')
    } else {
        $('.buy__info--col:nth-child(4)').removeClass('hidden')
        $('.buy__info--col:nth-child(5)').removeClass('hidden')
        $('.payment-form .appointment-free-slots').text(classObject.available_slots);
    }
    $('.payment-form .employee-name').text(trainer ? trainer.name : '');
    $('.payment-form .appointment-desc').html(classObject.service.description);

    let intervalWindow = false,
        intervalMessage = '';
    if (classObject.booking_window) {
        const now = moment().unix();
        const bookingStart = moment(classObject.booking_window.start_date_time).unix();
        const bookingEnd = moment(classObject.booking_window.end_date_time).unix();
        const appointmentStart = moment(classObject.start_date).unix();

        if (now < bookingStart) {
            let startDateForRecord = moment(classObject.booking_window.start_date_time).format('DD.MM.YYYY HH:mm');
            intervalMessage = `Запись на данное занятие пока еще не началась, но будет доступна с ${startDateForRecord}`;
            intervalWindow = false;
        } else if (now > bookingEnd || now > appointmentStart) {
            intervalMessage = 'Запись на данное занятие уже закончена';
            intervalWindow = false;
        } else {
            intervalWindow = true;
        }
    } else {
        intervalWindow = true;
    }

    let detail = await loadDetailedAppointment(classObject.appointment_id);
    // $ui.data.detail = detail;

    await fillTrainerInfo($ui, trainer?.id)

    if(isViewonly()) {
        $ui.$modalFooter.removeClass('overlay-info-visible');
        return false
    }

    $ui.$buttonClass.off().on('click', async function () {
        await handleClassRecord($ui, detail)
    });

    let ticket = await avalilableTicketForServiceId(detail.service.id, detail.employee.id, detail.start_date);

    let isPremium = ticket ?? ticket.find(r => r.item_id === 'c889a53b-f5cc-11ef-9b42-04d9c8bdfd54')
    if (isPremium) {
        $ui.$additionalInfoModal.text('У вас есть премиум-карта, вы можете записаться раньше чем все остальные.');
        $ui.$buttonClass.removeClass('hidden');
        $ui.$modalFooter.removeClass('overlay-info-visible');
    } else {
        if (detail.already_booked) {
            if (detail.status === 'temporarily_reserved_need_payment') {
                if (ticket) {
                    $ui.$buttonClass.removeClass('hidden');
                } else {
                    $ui.$additionalInfoModal.text('Вы предварительно записаны на занятие, Вам нужно оплатить его чтобы подтвердить запись. Через 10 минут оно автоматически отменится.');
                    await showPaymentOptions($ui, detail.service.id);
                }
            } else {
                $ui.$additionalInfoModal.text(`Вы уже записаны на это занятие, оно начнется в ${detail.start_date} в помещении "${detail.room.title}". Вы можете посмотреть подробную информацию в своем расписании.`);
            }
            $ui.$modalFooter.removeClass('overlay-info-visible');
        } else {
            if (detail.booking_online && intervalWindow) {
                if (detail.payment_required) {
                    let ticket = await avalilableTicketForServiceId(detail.service.id, detail.employee.id, detail.start_date);
                    if (ticket) {
                        $ui.$additionalInfoModal.text('У вас есть доступ к этому занятию, Вы можете записаться.');
                        $ui.$buttonClass.removeClass('hidden');
                        $ui.$modalFooter.removeClass('overlay-info-visible');
                    } else {
                        $ui.$additionalInfoModal.text('Это занятие требует оплаты, пожалуйста сначала оплатите его.');
                        $ui.$modalFooter.removeClass('overlay-info-visible');
                        await showPaymentOptions($ui, detail.service.id);
                    }
                } else {
                    $ui.$buttonClass.removeClass('hidden');
                    $ui.$modalFooter.removeClass('overlay-info-visible');
                }
            } else {
                $ui.$additionalInfoModal.text(intervalWindow ? 'На это занятие нельзя записаться онлайн' : intervalMessage);
                $ui.$contacts.removeClass('hidden');
                $ui.$modalFooter.removeClass('overlay-info-visible');
            }
        }
    }
}

export async function rateAppointment(appointment_id, rating, comment) {
    return await api.post('appointment_rating', {
        appointment_id,
        rating,
        comment
    })
}

export async function drawCoachModal(trainerId) {
    // $('.modal.is-open').each(function () {
    //     MicroModal.close($(this).attr('id'))
    // })
    MicroModal.show('coach-info');
    let $ui = initCoachModalUI();
    let $contacts = buildContacts('Рецепция');
    $ui.$contacts.empty().append($contacts)
    await fillTrainerInfo($ui, trainerId)
}

window.drawCoachModal = drawCoachModal

export async function drawRateModal($row) {
    let appointmentId = $row.data('appointment-id'),
        trainerId = $row.data('employee-id'),
        appointment = $row.data('appointment'),
        $ui = initRateModalUI();

    let $contacts = buildContacts('Рецепция');
    $ui.$contacts.empty().append($contacts)
    console.log('appo', appointment)
    if (appointment.rating) {
        $ui.$appointmentNeedRateContainer.hide();
        $ui.$appointmentAlreadyRateContainer.show();
        if (appointment.comment) {
            $ui.$appointmentAlreadyRateComment.text(appointment.comment)
        } else {
            $ui.$appointmentAlreadyRateComment.text('')
        }

        let $stars = [];
        for (let i = 0; i < 5; i++) {
            if (appointment.rating > i) {
                $stars.push($('<i class="fa fa-star active"></i>'));
            } else {
                $stars.push($('<i class="fa fa-star"></i>'));
            }
        }
        $ui.$appointmentAlreadyRateRating.empty().append($stars);

    } else {
        $ui.$appointmentNeedRateContainer.show();
        $ui.$appointmentAlreadyRateContainer.hide();

        let selectedRating = 0;

        $('body').on('mouseenter', '.need-rate .appointment-rating i', function () {
            let value = $(this).data('rating');
            $('.need-rate .appointment-rating i').each(function () {
                $(this).toggleClass('active', $(this).data('rating') <= value);
            });
        });

        $('body').on('mouseleave', '.need-rate .appointment-rating', function () {
            $('.need-rate .appointment-rating i').each(function () {
                $(this).toggleClass('active', $(this).data('rating') <= selectedRating);
            });
        });

        $('body').on('click', '.need-rate .appointment-rating i', function () {
            selectedRating = $(this).data('rating');
        });

        $('body').on('click', '.need-rate .appointment-rating i', function () {
            selectedRating = $(this).data('rating');
        });
        $('body').on('click', '.need-rate .employee-create-rate', async function () {
            if (selectedRating === 0)
                return notify.info('Выберите оценку от 1 до 5');

            let response = await rateAppointment(appointmentId, selectedRating, $ui.$appointmentNeedRateComment.val())
            if (response && response.result) {
                notify.success('Спасибо за оценку!');
                coachCache.clear();
                $renderStats();
                MicroModal.close('rate-form');
            }

        });

    }

    MicroModal.show('rate-form');
    await fillTrainerInfo($ui, trainerId)
}

export async function drawPersonalModal($row, personalObject) {
    let $ui = initPaymentModalUi($row, 'personal', 'personalObject', personalObject)
    MicroModal.show('payment-form');
    resetModal($ui)
    $ui.$modalTitle.text(personalObject.room.title);
    $('.buy__info div:nth-child(4)').addClass('hidden')
    $('.buy__info div:nth-child(5)').addClass('hidden')


    let $contacts = buildContacts('ОП');
    $ui.$contacts.empty().append($contacts)
    /* APPOINTMENT INFO */
    $ui.$appointmentTitle.text(personalObject.service.title)
    if (!personalObject.description)
        $ui.$appointmentInfoContainer.addClass('hidden');
    $ui.$appointmentDesc.html(personalObject.description)
    $ui.$appointmentTime.text(moment(personalObject.start_date).format('DD.MM.YYYY HH:mm'))
    $ui.$appointmentDuration.text(personalObject.duration);

    if (personalObject.reserve) {
        $ui.$appointmentCommercial.removeClass('hidden');
    } else {
        $ui.$appointmentCommercial.addClass('hidden');
    }

    await fillTrainerInfo($ui, personalObject.employee.id)


    $ui.$modalFooter.addClass('overlay-info-visible');


    $ui.$buttonClass.off().on('click', async function () {
        await handlePersonalRecord($ui, personalObject.service.id, personalObject.employee.id, personalObject.start_date);
    });

    if (personalObject.reserve) {
        let ticket = await avalilableTicketForServiceId(personalObject.service.id, personalObject.employee.id, personalObject.start_date);

        if (ticket) {
            $ui.$additionalInfoModal.text('У вас есть доступ к этому занятию, Вы можете записаться.');
            $ui.$buttonClass.removeClass('hidden');
            $ui.$modalFooter.removeClass('overlay-info-visible');
        } else {
            $ui.$additionalInfoModal.text('Это занятие требует оплаты, пожалуйста сначала оплатите его.');
            $ui.$modalFooter.removeClass('overlay-info-visible');
            await showPaymentOptions($ui, personalObject.service.id);
        }
    } else {
        $ui.$additionalInfoModal.text('Вы можете записаться на это занятие');
        $ui.$buttonClass.removeClass('hidden');
        $ui.$modalFooter.removeClass('overlay-info-visible');
    }


    /*
        if (detail.already_booked) {
            if (detail.status === 'temporarily_reserved_need_payment') {
                let ticket = await avalilableTicketForServiceId(detail.service.id, detail.employee.id, detail.start_date);
                if(ticket){
                    $ui.$buttonClass.removeClass('hidden');
                }else{
                    $ui.$additionalInfoModal.text('Вы предварительно записаны на занятие, Вам нужно оплатить его чтобы подтерждить запись. Через 10 минут оно автоматически отменится.');
                    await showPaymentOptions($ui, detail.service.id);
                }
            } else {
                $ui.$additionalInfoModal.text(`Вы уже записаны на это занятие, оно начнется в ${detail.start_date} в помещении "${detail.room.title}". Вы можете посмотреть подробную информацию в своем расписании.`);
            }
            $ui.$modalFooter.removeClass('overlay-info-visible');
        } else {
            if (detail.booking_online && intervalWindow) {
                if(detail.payment_required){
                    let ticket = await avalilableTicketForServiceId(detail.service.id, detail.employee.id, detail.start_date);
                    console.log('avalilableTicketForServiceId ticket', ticket)
                    if (!ticket) {
                        $ui.$additionalInfoModal.text('Это занятие требует оплаты, пожалуйста сначала оплатите его.');
                        $ui.$modalFooter.removeClass('overlay-info-visible');
                        await showPaymentOptions($ui, detail.service.id);
                    }else {
                        $ui.$additionalInfoModal.text('У вас есть доступ к этому занятию, Вы можете записаться.');
                        $ui.$buttonClass.removeClass('hidden');
                        $ui.$modalFooter.removeClass('overlay-info-visible');
                    }
                }else{
                    $ui.$buttonClass.removeClass('hidden');

                }
            } else {
                $ui.$additionalInfoModal.text(intervalWindow ? 'На это занятие нельзя записаться онлайн' : intervalMessage);
                $ui.$contacts.removeClass('hidden');
                $ui.$modalFooter.removeClass('overlay-info-visible');
            }
        }*/
}

export async function drawPersonalPreModal($row, personalObject = false) {
    if (!personalObject)
        personalObject = $row.data('personalObject')
    console.log('personalObject', personalObject)
    let $ui = initPaymentModalUi($row, 'prePersonal', 'personalObject', personalObject)
    MicroModal.show('payment-form');
    resetModal($ui)

    let $contacts = buildContacts('ОП');
    $ui.$contacts.empty().append($contacts)
    $ui.$modalTitle.text('Индивидуальное занятие');
    $('.buy__info div:nth-child(4)').addClass('hidden')
    $('.buy__info div:nth-child(5)').addClass('hidden')


    /* APPOINTMENT INFO */
    $ui.$appointmentTitle.text(personalObject.service.title)
    $ui.$appointmentInfoContainer.addClass('hidden');
    $ui.$appointmentTime.text(moment(personalObject.full_date).format('DD.MM.YYYY HH:mm'))
    $ui.$appointmentDuration.text(personalObject.service.duration);

    if (personalObject.payment_required) {
        $ui.$appointmentCommercial.removeClass('hidden');
    } else {
        $ui.$appointmentCommercial.addClass('hidden');
    }

    await fillTrainerInfo($ui, personalObject.trainer.id)


    $ui.$buttonClass.off().on('click', async function () {
        await handlePersonalRecord($ui, personalObject.service.id, personalObject.trainer.id, personalObject.full_date);
    });

    if (personalObject.payment_required) {
        let ticket = await avalilableTicketForServiceId(personalObject.service.id, personalObject.trainer.id, personalObject.full_date);
        if (ticket) {
            $ui.$additionalInfoModal.text('У вас есть доступ к этому занятию, Вы можете записаться.');
            $ui.$buttonClass.removeClass('hidden');
            $ui.$modalFooter.removeClass('overlay-info-visible');
        } else {
            $ui.$additionalInfoModal.text('Это занятие требует оплаты, пожалуйста сначала оплатите его.');
            $ui.$modalFooter.removeClass('overlay-info-visible');
            await showPaymentOptions($ui, personalObject.service.id);
        }
    } else {
        $ui.$additionalInfoModal.text('Вы можете записаться на это занятие');
        $ui.$buttonClass.removeClass('hidden');
        $ui.$modalFooter.removeClass('overlay-info-visible');
    }
}

export async function resetModal($ui) {
    $ui.$buttonClass.off().addClass('hidden');
    $ui.$buttonRefill.off().addClass('hidden');
    $ui.$buttonBuyByDeposit.off().addClass('hidden');
    $ui.$buttonBuyByBank.off().addClass('hidden');
    $ui.$additionalInfoModal.text('');
    $ui.$variants.empty().addClass('hidden');
    $ui.$modalFooter.addClass('overlay-info-visible');
    $ui.$employeeStarsContainer.find('.fa-star').removeClass('active');
    $ui.$employeeReviewsCount.text('')
    $ui.$employeeSpecsContainer.addClass('hidden');
    $ui.$employeeReviewsList.empty();

    $ui.$employeeStarsContainer.addClass('hidden');
    $ui.$employeeReviewsList.addClass('hidden');
    $ui.$employeeReviewsButton.addClass('hidden');

    $ui.$appointmentInfoContainer.removeClass('hidden');


}

export function createReview(rating, author, review) {
    let $ratings = [],
        $review = $(`<div class="review">
            <div class="review__rating"></div>
            <div class="review__text">${review}</div>
        </div>`);

    for (let i = 0; i < 5; i++) {
        if (rating > i) {
            $ratings.push($('<i class="fa fa-star" style="color: #aad149"></i>'));
        } else {
            $ratings.push($('<i class="fa fa-star" style="color: #999999"></i>'));
        }
    }
    $review.find('.review__rating').append($ratings);
    return $review;
}

export async function fillTrainerInfo($ui, trainerId) {
    if (trainerId) {
        $ui.$employeeInfo.show();
        $ui.$employeeReviewsList.addClass('hidden');
        $ui.$employeeReviewsList.empty();
        $ui.$employeeInfo.addClass('overlay-info-visible');
        $ui.$employeePhoto.addClass('hidden');
        let trainer = await loadTrainer(trainerId)
        $ui.$employeeName.text(trainer ? trainer.name : '');


        if (trainer.photo) {
            $ui.$employeePhoto.attr('src', trainer.photo);
            $ui.$employeePhoto.removeClass('hidden');
        } else {
            $ui.$employeePhoto.addClass('hidden');
        }


        if (trainer && trainer.position && trainer.position.title) {
            if ($ui.$employeePosition.length)
                $ui.$employeePosition.text(trainer.position.title);
        } else {
            if ($ui.$employeePosition.length)
                $ui.$employeePosition.hide();
        }

        if (trainer && trainer.biography && trainer.biography !== '') {
            if ($ui.$employeeBioBlock.length) {
                $ui.$employeeBioBlock.show();
                $ui.$employeeBio.html(trainer.biography);
            }
        } else {
            if ($ui.$employeeBioBlock.length)
                $ui.$employeeBioBlock.hide();
        }

        if (trainer && trainer.description && trainer.description !== '') {
            if ($ui.$employeeDescriptionBlock.length) {
                $ui.$employeeDescriptionBlock.show();
                $ui.$employeeDescription.html(trainer.description);
            }
        } else {
            if ($ui.$employeeDescriptionBlock.length)
                $ui.$employeeDescriptionBlock.hide();
        }

        if (trainer && trainer.awards && trainer.awards !== '') {
            if ($ui.$employeeAwardsBlock.length) {
                $ui.$employeeAwardsBlock.show();
                $ui.$employeeAwards.html(trainer.awards);
            }
        } else {
            if ($ui.$employeeAwardsBlock.length)
                $ui.$employeeAwardsBlock.hide();
        }

        if (trainer.ratings) {
            $ui.$employeeSpecsContainer.removeClass('hidden');
            $ui.$employeeStarsContainer.removeClass('hidden');
            let rating = Math.round(trainer.ratings.rating),
                ratingCount = trainer.ratings.count;
            $ui.$employeeReviewsCount.text(ratingCount)
            $ui.$employeeStarsContainer.find(`.fa-star:nth-child(-n+${rating})`).addClass('active');

            if (trainer.reviews.length > 0) {
                let $reviews = trainer.reviews.reduce((acc, r) => {
                    if (r.review !== '') {
                        acc.push(createReview(r.rating, r.client_name.split(' ')[1], r.review));
                    }
                    return acc;
                }, [])

                if ($reviews.length > 0) {
                    $ui.$employeeReviewsButton.removeClass('hidden');
                    $ui.$employeeReviewsList.append($reviews);
                    $ui.$employeeReviewsButton.text(`Показать отзывы (${$reviews.length})`)
                    $ui.$employeeReviewsButton.off().on('click', function () {
                        console.log('click')
                        if ($ui.$employeeReviewsList.has(':visible').length) {
                            $ui.$employeeReviewsButton.text(`Показать отзывы (${$reviews.length})`)
                            $ui.$employeeReviewsList.addClass('hidden');
                        } else {
                            $ui.$employeeReviewsList.removeClass('hidden');
                            $ui.$employeeReviewsButton.text(`Скрыть отзывы (${$reviews.length})`)
                        }
                    })
                } else {
                    $ui.$employeeReviewsButton.addClass('hidden');
                }
            }
        } else {
            $ui.$employeeSpecsContainer.addClass('hidden');
        }


        $ui.$employeeInfo.removeClass('overlay-info-visible');
    } else {
        $ui.$employeeInfo.hide();
    }
}

export function initPaymentModalUi($this, type, objectKey, object) {
    return {
        $row: $this,
        $variants: $('.payment-form .variants'),
        $modalOverlay: $('.payment-form .modal__overlay'),
        $modal: $('.payment-form'),
        $modalFooter: $('.payment-form .modal__footer'),
        $buttonClass: $('.payment-form .button-buy-class'),
        $buttonRefill: $('.payment-form .button-buy-refill'),
        $buttonBuyByDeposit: $('.payment-form .button-buy-deposit'),
        $buttonBuyByBank: $('.payment-form .button-buy-sberbank'),
        $additionalInfoModal: $('.payment-form .additional_info'),
        $payRequirement: $('.payment-form .is-payment-required'),
        $modalTitle: $('.payment-form .appointment-room'),


        $contacts: $('.payment-form .contacts'),
        $controls: $('.payment-form .controls'),

        $appointmentCommercial: $('.payment-form .is-payment-required'),
        $appointmentTitle: $('.payment-form .appointment-name'),
        $appointmentInfoContainer: $('.payment-form .appointment__info'),
        $appointmentDesc: $('.payment-form .appointment-desc'),
        $appointmentTime: $('.payment-form .appointment-time'),
        $appointmentDuration: $('.payment-form .appointment-duration'),

        $employeeInfo: $('.payment-form .employee__info'),
        $employeePhotoDiv: $('.payment-form .employee__info__photo'),
        $employeePhoto: $('.payment-form .employee__info__photo--image'),

        $employeeName: $('.payment-form .employee__info--name'),
        $employeePosition: $('.payment-form .employee__info--position'),

        $employeeBioBlock: $('.payment-form .employee__info--bio-block'),
        $employeeDescriptionBlock: $('.payment-form .employee__info--description-block'),
        $employeeAwardsBlock: $('.payment-form .employee__info--awards-block'),

        $employeeBio: $('.payment-form .employee__info--bio'),
        $employeeDescription: $('.payment-form .employee__info--description'),
        $employeeAwards: $('.payment-form .employee__info--awards'),

        $employeeSpecsContainer: $('.payment-form .employee__info--specs'),
        $employeeRatingContainer: $('.payment-form .employee-info-rating'),
        $employeeStarsContainer: $('.payment-form .employee__info--stars'),

        $employeeReviewsList: $('.payment-form .employee__info--reviews'),
        $employeeReviewsCount: $('.payment-form .employee__info--reviews-count'),
        $employeeReviewsButton: $('.payment-form .employee__info--review-control'),

        data: {[objectKey]: object},
        type,
    }
}

export function initCoachModalUI() {
    return {
        $modal: $('.coach-info'),
        $modalOverlay: $('.coach-info .modal__overlay'),
        $modalContent: $('.coach-info .modal__content'),
        $modalFooter: $('.coach-info .modal__footer'),
        $modalTitle: $('.coach-info .modal__title'),
        $contacts: $('.coach-info .contacts'),


        $employeeInfo: $('.coach-info .employee__info'),
        $employeePhotoDiv: $('.coach-info .employee__info__photo'),
        $employeePhoto: $('.coach-info .employee__info__photo--image'),

        $employeeName: $('.coach-info .employee__info--name'),
        $employeePosition: $('.coach-info .employee__info--position'),

        $employeeBioBlock: $('.coach-info .employee__info--bio-block'),
        $employeeDescriptionBlock: $('.coach-info .employee__info--description-block'),
        $employeeAwardsBlock: $('.coach-info .employee__info--awards-block'),

        $employeeBio: $('.coach-info .employee__info--bio'),
        $employeeDescription: $('.coach-info .employee__info--description'),
        $employeeAwards: $('.coach-info .employee__info--awards'),

        $employeeSpecsContainer: $('.coach-info .employee__info--specs'),
        $employeeRatingContainer: $('.coach-info .employee-info-rating'),
        $employeeStarsContainer: $('.coach-info .employee__info--stars'),

        $employeeReviewsList: $('.coach-info .employee__info--reviews'),
        $employeeReviewsCount: $('.coach-info .employee__info--reviews-count'),
        $employeeReviewsButton: $('.coach-info .employee__info--review-control')
    }
}

export function initRateModalUI() {
    return {
        $modal: $('.rate-form'),
        $modalOverlay: $('.rate-form .modal__overlay'),
        $modalFooter: $('.rate-form .modal__footer'),
        $modalTitle: $('.rate-form .appointment-room'),
        $contacts: $('.rate-form .contacts'),

        $appointmentAlreadyRateContainer: $('.rate-form .already-rate'),
        $appointmentAlreadyRateRating: $('.rate-form .already-rate .appointment-rating'),
        $appointmentAlreadyRateComment: $('.rate-form .already-rate .appointment-comment'),

        $appointmentNeedRateContainer: $('.rate-form .need-rate'),
        $appointmentNeedRateRating: $('.rate-form .need-rate .appointment-rating'),
        $appointmentNeedRateComment: $('.rate-form .need-rate .appointment-comment'),
        $appointmentNeedRateCreate: $('.rate-form .need-rate .employee-create-rate'),

        $appointmentTitle: $('.rate-form .appointment-name'),
        $appointmentInfoContainer: $('.rate-form .appointment__info'),

        $employeeInfo: $('.rate-form .employee__info'),
        $employeePhotoDiv: $('.rate-form .employee__info__photo'),
        $employeePhoto: $('.rate-form .employee__info__photo--image'),

        $employeeName: $('.rate-form .employee__info--name'),
        $employeePosition: $('.rate-form .employee__info--position'),

        $employeeBioBlock: $('.rate-form .employee__info--bio-block'),
        $employeeDescriptionBlock: $('.rate-form .employee__info--description-block'),
        $employeeAwardsBlock: $('.rate-form .employee__info--awards-block'),

        $employeeBio: $('.rate-form .employee__info--bio'),
        $employeeDescription: $('.rate-form .employee__info--description'),
        $employeeAwards: $('.rate-form .employee__info--awards'),

        $employeeSpecsContainer: $('.rate-form .employee__info--specs'),
        $employeeRatingContainer: $('.rate-form .employee-info-rating'),
        $employeeStarsContainer: $('.rate-form .employee__info--stars'),

        $employeeReviewsList: $('.rate-form .employee__info--reviews'),
        $employeeReviewsCount: $('.rate-form .employee__info--reviews-count'),
        $employeeReviewsButton: $('.rate-form .employee__info--review-control')
    }
}

export async function drawSpaPreModal($row, spaObject = false) {
    if (!spaObject)
        spaObject = $row.data('spaObject');

    let $ui = initPaymentModalUi($row, 'preSpa', 'spaObject', spaObject)
    MicroModal.show('payment-form');
    resetModal($ui)

    let $contacts = buildContacts('SPA');
    $ui.$contacts.empty().append($contacts)
    console.log('spaObject', spaObject)
    $ui.$modalTitle.text('Посещение салона красоты');
    $('.buy__info div:nth-child(4)').addClass('hidden')
    $('.buy__info div:nth-child(5)').addClass('hidden')

    let plainDate = $row.data('date'),
        slot = plainDate.replace(' ', 'T').slice(0, 16),
        human_date = moment(slot).format('DD.MM.YYYY HH:mm');

    spaObject.custom_slot = slot;

    /* APPOINTMENT INFO */
    $ui.$appointmentTitle.text(spaObject.service.title)
    if (!spaObject.comment)
        $ui.$appointmentInfoContainer.addClass('hidden');
    $ui.$appointmentDesc.html(spaObject.comment)

    $ui.$appointmentTime.text(human_date)
    $ui.$appointmentDuration.text(spaObject.service.length);

    if (spaObject.service.payment_required) {
        $ui.$appointmentCommercial.removeClass('hidden');
    } else {
        $ui.$appointmentCommercial.addClass('hidden');
    }

    await fillTrainerInfo($ui, spaObject.staff.id)


    $ui.$buttonClass.off().on('click', async function () {
        await handleSpaRecord($ui, spaObject.service.id, spaObject.staff.id, slot);
    });

    if (spaObject.service.payment_required) {
        let ticket = await avalilableTicketForServiceId(spaObject.service.id, spaObject.staff.id, slot);
        if (ticket) {
            $ui.$additionalInfoModal.text('У вас есть доступ к этому занятию, Вы можете записаться.');
            $ui.$buttonClass.removeClass('hidden');
            $ui.$modalFooter.removeClass('overlay-info-visible');
        } else {
            $ui.$additionalInfoModal.text('Это занятие требует оплаты, пожалуйста сначала оплатите его.');
            $ui.$modalFooter.removeClass('overlay-info-visible');
            await showPaymentOptions($ui, spaObject.service.id);
        }
    } else {
        $ui.$additionalInfoModal.text('Вы можете записаться на это занятие');
        $ui.$buttonClass.removeClass('hidden');
        $ui.$modalFooter.removeClass('overlay-info-visible');
    }
}

window.initPaymentModalUi = initPaymentModalUi
window.getServiceIdFromUrl = getServiceIdFromUrl;
window.findPersonal = findPersonal;
window.findInMyAppointments = findInMyAppointments;

export const appointmentStatuses = {
    "planned": "Запланировано",
    "canceled": "Отменено",
    "ended": "Проведено",
    "passes": "Проводится"
}
export const appointmentStatusesClass = {
    "Запланировано": "planned",
    "Отменено": "canceled",
    "Проведено": "ended",
    "Проводится": "passes"
}

/* DEBTS FORM MODAL */
export async function openDebtModal(debtId = false) {
    return new Promise((resolve, reject) => {
        if (debtId) {
            MicroModal.show("pay-debts")
            $(`.debt-checkbox[data-id="${debtId}"]`).click()
        }
        resolve();
    })
}

window.openDebtModal = openDebtModal
/* PAYMENT FORM MODAL */

export const paymentForm = {
    currentResponse: null,
    totalAmount: 0,
    shopInputs: [],
    totalDiscount: 0
}

export function createPackageHistoryItem(historyItem) {
    return $(`<div class="ticket-history-item">
        <div class="history-item-head">
            <span class="history-item__date">${moment(historyItem.date, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YY HH:mm')}</span>
            <span class="history-item__status ${appointmentStatusesClass.hasOwnProperty(historyItem.status) ? appointmentStatusesClass[historyItem.status] : ''}">${historyItem.status}</span>
            <span class="history-item__duration"><i class="fa fa-clock"></i>${historyItem.duration} м.</span>
            
        </div>
        <div class="history-item-footer">
            <span class="history-item__user">${historyItem?.client}</span>
            <span class="history-item__service">${historyItem?.service}</span>
            <span class="history-item__employee ${historyItem?.employee_id === null ? 'hidden' : ''}" data-view-employee="${historyItem.employee_id}"><i class="fa fa-person"></i>${historyItem.employee.replaceAll('(удален)', '')}</span>
            <span class="history-item__room ${historyItem?.room === null ? 'hidden' : ''}"><i class="fa fa-hotel"></i>${historyItem.room}</span>
        </div>
    </div>`)
}

export function drawHistoryModal(historyArray = []) {
    console.log('historyArray', historyArray)
    $('.ticket-history-list').empty();
    // let $contacts = buildContacts('Другое');
    // $('.ticket-history').find('.contacts').empty().append($contacts);
    if (historyArray.length) {
        for (let historyItem of historyArray) {
            $('.ticket-history-list').append(createPackageHistoryItem(historyItem));
        }
    }
    MicroModal.show('ticket-history');
}

function decodeHTML(str) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = str;
    return textarea.value;
}

function showProductFormError(message) {
    const $productForm = $('.product-form');

    paymentForm.currentResponse = null;
    paymentForm.totalAmount = 0;
    paymentForm.totalDiscount = 0;
    paymentForm.shopInputs = [];

    $productForm.find('.appointment-name').text('Услуга недоступна');
    $productForm.find('[data-product-image]').hide();
    $productForm.find('[data-product-desc]').text(message);
    $productForm.find('.product__info--price, .product__info--promotions').addClass('hidden');
    $productForm.find('.form-inputs').empty();
    $productForm.find('.modal__footer .total, .modal__footer .controls').addClass('hidden');
}

function resetProductForm() {
    const $productForm = $('.product-form');

    $productForm.find('.product__info--price, .product__info--promotions').removeClass('hidden');
    $productForm.find('.modal__footer .total, .modal__footer .controls').removeClass('hidden');
}

export async function drawProductForm(serviceId) {
    const $this = $('[data-product-id="' + serviceId + '"]');
    const productId = serviceId,
        service = person.allProducts?.find(p => p.id === serviceId);

    resetProductForm();

    if (service && service?.pictures?.length) {
        $('.product-form [data-product-image]').show();
        $('.product-form [data-product-image]').attr('src', service.pictures[0]);
    }else{
        $('.product-form [data-product-image]').hide();
    }

    $('.product-form .modal__container').addClass('overlay-info-visible');
    MicroModal.show("product-form");

    let productContactCategory = person.shopConfig?.[service?.category?.id] ?? 'Другое';
    let $contacts = buildContacts(productContactCategory);

    $('.product-form').find('.contacts').empty().append($contacts);
    let responseRaw;
    try {
        responseRaw = await api.get(`cart_cost/?cart={"cart_array":[{"purchase_id":"${productId}","count":1}]}`);
    } catch (error) {
        showProductFormError('Не удалось загрузить информацию об услуге. Попробуйте позже.');
        return;
    } finally {
        $('.product-form .modal__container').removeClass('overlay-info-visible');
    }

    if (!responseRaw?.result || !Array.isArray(responseRaw?.data?.cart) || !responseRaw.data.cart.length) {
        showProductFormError(responseRaw?.error_message || 'Эта услуга больше недоступна для покупки.');
        return;
    }

    paymentForm.currentResponse = responseRaw.data;
    paymentForm.totalAmount = paymentForm.currentResponse.total_amount || 0;
    paymentForm.totalDiscount = paymentForm.currentResponse.total_discount || 0;

    console.log('totalAmount', paymentForm.totalAmount);
    console.log('totalDiscount', paymentForm.totalDiscount);

    let price = paymentForm.currentResponse.cart[0].price;
    let priceAfterDiscount = paymentForm.currentResponse.cart[0].price_with_discount;

    const product = paymentForm.currentResponse.cart[0].purchase;
    $('.product-form .appointment-name').text(product.title);
    $('.product-form [data-product-desc]').html(decodeHTML(product.description) || 'Описание отсутствует');

    if (price === priceAfterDiscount) {
        $('.product-form [data-product-old-price]').addClass('hidden');
    } else {
        $('.product-form [data-product-old-price]').removeClass('hidden');
    }

    $('.product-form .product__info--promotions').empty();
    paymentForm.currentResponse.promotions.forEach(promotion => {
        $('.product-form .product__info--promotions').append(
            `<div class="product__info--promotion">${promotion.title}</div>`
        );
    });

    $('.product-form [data-product-old-price]').text(price.toLocaleString());
    $('.product-form [data-product-price]').text(priceAfterDiscount.toLocaleString());
    console.log('product', product)



    $('.product-form .modal__content').find('.account-input').remove();
    paymentForm.shopInputs = [];

    paymentForm.currentResponse.may_be_payment.forEach(account => {
        const balance = account.balance.toFixed(2);
        const maxAmount = account.payment_amount.toFixed(2);
        const $accountInput = $('<div>').addClass('account-input');
        let $inputGroup = $('<div>').addClass('input-group');
        const $input = $('<input>', {
            type: 'number',
            min: 0,
            max: maxAmount,
            step: 0.01,
            placeholder: `Макс. ${maxAmount} ₽`
        });
        $input.on('input', updatePaymentState);

        $inputGroup.append(
            $input,
            $('<button class="clear-input"><i class="fas fa-backspace"></i></button>'),
            $('<button class="fill-input"><i class="fa fa-coins"></i></button>')
        );

        $accountInput.append(
            $('<label>').text(`${account.title} (Баланс: ${balance} ₽)`),
            $inputGroup
        );

        $('.product-form .modal__content .form-inputs').append($accountInput);
        paymentForm.shopInputs.push({
            id: account.id,
            type: account.type,
            input: $input,
            max: maxAmount
        });
    });

    console.log(paymentForm.shopInputs);
    updatePaymentState();
}

String.prototype.toLocaleDigits = function () {
    let num = parseFloat(this.replace(/\s+/g, '').replace(',', '.')); // Убираем пробелы и заменяем запятую на точку
    if (isNaN(num)) return 'NaN'; // Проверка на число

    return num.toLocaleString('ru-RU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).replace(',', '.'); // Меняем запятую на точку
};
Number.prototype.toLocaleDigits = function () {
    if (isNaN(this)) return 'NaN'; // Проверка на число

    return this.toLocaleString('ru-RU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).replace(',', '.'); // Меняем запятую на точку
};

function updateTotalAmount() {
    console.log('updateTotalAmount')
    let remainingAmount = paymentForm.totalAmount;

    console.log('totalAmount', paymentForm.totalAmount)

    getShopInputs().forEach(({input}) => {
        const value = parseFloat(input.val()) || 0;
        remainingAmount -= value;
    });


    $('.product-form .pay-debt-sum').text(remainingAmount.toLocaleDigits());

    if (paymentForm.totalDiscount > 0) {
        $('.product-form .discount-message').removeClass('hidden');
        $('.product-form .discount-total').text(paymentForm.totalDiscount.toLocaleDigits());
    } else {
        $('.product-form .discount-message').addClass('hidden');
    }

}

function getShopInputs($input) {
    if (!$input) {
        console.log('origin', paymentForm.shopInputs)
        return paymentForm.shopInputs;
    }

    const index = paymentForm.shopInputs.findIndex(shopInput => {
        return $(shopInput.input).is($input)
    });
    if (index > -1) {
        const [matchedInput] = paymentForm.shopInputs.splice(index, 1);
        paymentForm.shopInputs.unshift(matchedInput);
        console.log('matched', matchedInput)
    }
    console.log('shuffled', paymentForm.shopInputs)
    return paymentForm.shopInputs;
}

function updatePaymentState($input = false) {

    console.log('updatePaymentState', $input)

    let remainingAmount = paymentForm.totalAmount;

    if ($input?.target !== null) {
        $input = $($input.target);
    }

    getShopInputs($input).forEach(({input, max}) => {
        let value = parseFloat(input.val()) || 0;
        console.log('shopInputs', input, value, max)
        if (value < 0) {
            input.val(false);
            value = 0;
        }
        if (value > max) {
            value = max;
            input.val(parseFloat(value).toFixed(2));
        }
        if (value > remainingAmount) {
            value = remainingAmount;
            input.val(parseFloat(value).toFixed(2));
        }

        if (remainingAmount - value >= 0)
            remainingAmount -= value;
    });

    const $buyBtn = $('.product-form .button-buy-product');
    if (remainingAmount < 0 || isNaN(remainingAmount)) {
        $buyBtn.prop('disabled', true);
    } else {
        $buyBtn.prop('disabled', false);
    }

    getShopInputs($input).forEach(({input, max}) => {
        let currentValue = parseFloat(input.val()) || 0;
        const currentMax = Math.min(max, remainingAmount - currentValue).toFixed(2);
        input.attr('max', currentMax);
        input.attr('placeholder', `Макс. ${currentMax} ₽`);
    });

    updateTotalAmount()
}

window.paymentForm = paymentForm;
window.drawProductForm = drawProductForm;
window.updateTotalAmount = updateTotalAmount;
window.getShopInputs = getShopInputs;
window.updatePaymentState = updatePaymentState;
